import styled from 'styled-components';

export const ListStyled = styled.ul`
  list-style: none;
  margin: 10px 0;
`;
